/**
 * Determines whether the string passed in starts with the.
 * Currently used in billing receipt emails for wording.
 *
 * @param string
 * @returns {boolean}
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get capitalizeWord () {
        return capitalizeWord;
    },
    get normalizeEmail () {
        return normalizeEmail;
    },
    get startsWithThe () {
        return startsWithThe;
    }
});
const startsWithThe = (string)=>{
    return string.toLowerCase().startsWith("the ");
};
const capitalizeWord = (word)=>{
    return word[0].toUpperCase() + word.substring(1).toLowerCase();
};
const normalizeEmail = (email)=>{
    if (typeof email !== "string") {
        return "";
    }
    return email.toLowerCase().trim();
};
